import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPhoneRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M8.8 3.7c1.4-.4 2.9.2 3.5 1.5l2 4.4q.7 2-.8 3.4l-1.2 1q1.9 3.7 5.7 5.9l1-1.4c.8-1 2.2-1.3 3.4-.8l4.4 2c1.3.6 2 2.1 1.5 3.5-1 3-4.2 5.8-8 5.1-8.8-1.5-15-7.8-16.6-16.5-.7-3.9 2-7 5.1-8m1.3 2.5L9.6 6c-2.3.8-4 3-3.5 5.4a17.5 17.5 0 0 0 14.5 14.5c2.5.5 4.6-1.2 5.4-3.5q0-.3-.2-.5l-4.4-2-.5.1-1.7 2.1q-.6.7-1.4.4A17 17 0 0 1 9.7 14q-.3-.8.3-1.5l2-1.5q.2-.2 0-.5z" })
});
export default SvgPhoneRegularIcon;
